// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_56-6";
export var headerCell = "_56-2";
export var loadingStateContent = "_56-8";
export var rowWrapper = "_56-4";
export var stickyAggregationCell = "_56-b";
export var stickyAggregationRow = "_56-7";
export var stickyColumnCell = "_56-a";
export var stickyColumnHeaderCell = "_56-9";
export var table = "_56-1";
export var virtualRowWrapper = "_56-5";
export var virtualTableContainer = "_56-0";
export var white = "_56-3";